import { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X, Youtube } from "lucide-react";
import { IMAGES, CONTACT } from "@/data/site";
import { Chapter, RevealLines, FadeUp, EASE } from "./motion";

export default function VideoSection() {
  const [open, setOpen] = useState(false);
  const videoRef = useRef(null);

  return (
    <section id="showreel" data-testid="video-section" className="relative overflow-hidden bg-[#1B1B1B] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="06" title="The Showreel" dark />
        <RevealLines
          className="mt-8 font-display text-4xl tracking-tight text-[#F7F5F2] md:text-6xl"
          lines={[<>Watch spaces</>, <>come <span className="italic text-[#B68D40]">alive.</span></>]}
        />

        <FadeUp delay={0.25} className="mt-14">
          <div className="relative h-[340px] overflow-hidden rounded-2xl md:h-[600px]">
            <video
              ref={videoRef}
              className="h-full w-full object-cover"
              src={IMAGES.video}
              poster={IMAGES.videoPoster}
              autoPlay
              muted
              loop
              playsInline
            />
            <div className="absolute inset-0 bg-black/35" />
            <button
              onClick={() => setOpen(true)}
              data-testid="showreel-play-btn"
              className="group absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
              aria-label="Play showreel"
            >
              <span className="glass-dark flex h-24 w-24 items-center justify-center rounded-full border border-white/30 transition-transform duration-500 group-hover:scale-110">
                <Play size={28} className="ml-1 fill-[#F7F5F2] text-[#F7F5F2]" />
              </span>
              <span className="absolute inset-0 -z-10 animate-ping rounded-full border border-[#B68D40]/40" />
            </button>
            <p className="absolute bottom-6 left-6 font-num text-[10px] uppercase tracking-[0.3em] text-[#F7F5F2]/70">
              Real Projects · Shot on Site · Bengaluru
            </p>
            <a
              href={CONTACT.youtube}
              target="_blank"
              rel="noreferrer"
              data-testid="showreel-youtube-link"
              className="glass-dark absolute bottom-5 right-5 flex items-center gap-2 rounded-full px-5 py-2.5 text-xs font-semibold text-[#F7F5F2] transition-colors hover:text-[#B68D40]"
            >
              <Youtube size={14} /> Full reels on YouTube
            </a>
          </div>
        </FadeUp>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="video-modal"
            className="fixed inset-0 z-[80] flex items-center justify-center bg-[#1B1B1B]/95 p-4 md:p-12"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          >
            <button data-testid="video-modal-close" className="absolute right-6 top-6 flex h-12 w-12 items-center justify-center rounded-full border border-[#F7F5F2]/25 text-[#F7F5F2] transition-colors hover:bg-[#B68D40] hover:text-[#1B1B1B]" aria-label="Close video">
              <X size={20} />
            </button>
            <motion.video
              src={IMAGES.video}
              poster={IMAGES.videoPoster}
              controls
              autoPlay
              className="max-h-[80vh] w-full max-w-5xl rounded-lg"
              initial={{ scale: 0.94, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: EASE }}
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
